import { } from "helpers/url_helper";

import {
    CREATE_MSTEAMS_CHANNEL,
    CREATE_MSTEAMS_CHANNEL_SUCCESS,
    CREATE_MSTEAMS_CHANNEL_FAIL,
    GET_MSTEAMS_CHANNELS,
    GET_MSTEAMS_CHANNELS_SUCCESS,
    GET_MSTEAMS_CHANNELS_FAIL,
    DELETE_MSTEAMS_CHANNEL,
    DELETE_MSTEAMS_CHANNEL_SUCCESS,
    DELETE_MSTEAMS_CHANNEL_FAIL
} from "./actionTypes";

export const createMsTeamsChannel = (data) => ({
    type: CREATE_MSTEAMS_CHANNEL,
    payload: data,
});

export const createMsTeamsChannelSuccess = (data) => ({
    type: CREATE_MSTEAMS_CHANNEL_SUCCESS,
    payload: data,
});

export const createMsTeamsChannelFail = (error) => ({
    type: CREATE_MSTEAMS_CHANNEL_FAIL,
    payload: error,
});

export const getMsTeamsChannels = () => ({
    type: GET_MSTEAMS_CHANNELS,
});

export const getMsTeamsChannelsSuccess = (data) => ({
    type: GET_MSTEAMS_CHANNELS_SUCCESS,
    payload: data,
});

export const getMsTeamsChannelsFail = (error) => ({
    type: GET_MSTEAMS_CHANNELS_FAIL,
    payload: error,
});

export const deleteMsTeamsChannel = (data) => ({
    type: DELETE_MSTEAMS_CHANNEL,
    payload: data,
});

export const deleteMsTeamsChannelSuccess = (data) => ({
    type: DELETE_MSTEAMS_CHANNEL_SUCCESS,
    payload: data,
});

export const deleteMsTeamsChannelFail = (error) => ({
    type: DELETE_MSTEAMS_CHANNEL_FAIL,
    payload: error,
});
